<template>
	<cTable ref="table" :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config">
		<template #footer>
			<div style="display: flex;margin-top: 5px;justify-content: flex-end;">
				<div style="display: flex;margin-left: 10px;" v-for="(child,key) in total" :key="key">
					{{key}}
					<div style="margin-left:5px">
						<div v-for="(item,itemKey) in child" :key="itemKey">
							<span>{{itemKey}}:</span>
							<span style="color: red;margin-left: 10px;">{{item}}</span>
						</div>
					</div>
				</div>
			</div>
			
		</template>
	</cTable>
</template>

<script>
	import {
		getList,
		Upload,
		createBill
	} from "@/api/cost/packetDeliveryCost";
	import {
		log,
	} from "@/api/finance/channelCost";
	import {
		getAgent
	} from "@/api/tracker/agent";
	import cTable from "@/base/common/index";
	import {
		getCurrency
	} from "@/api/finance/currency";
	import {
		getSelectType
	} from "@/api/public";
	import {
		getAllClient
	} from "@/api/user/client";
	import {
		getCountry
	} from "@/api/system/country";
	import numFun from "@/utils/numFun";
	export default {
		name: "packetDeliveryCost",
		components: {
			cTable
		},
		data() {
			let that = this;
			return {
				options: [],
				summary: [],
				total:{},
				methods: {
					list: getList,
					Upload,
					getAllClient,
					createBill,
					beforeHandleList:({data})=>{
						this.total = Object.values(data.summary).reduce((a,b)=>{
							a[b.name] = b
							delete b.name
							return a
						},{})
						return data.rows
					}
				},
				config: {
					height: 630,
				},
				modals: {
					createBill: {
						type: 'add',
						methods: {
							ok({
								row,
								close
							}) {
								this.$page
									.handleRequestMethods("createBill", row, true)
									.then(res => {
										this.$page.getList();
										close();
									});
							}
						},
						config: {
							title: this.$t('createBill'),
							modalBind: {
								width: 600,
								draggable: true,
							},
							formBind: {
								labelWidth: 140
							},
							rowBind: {
								gutter: 16,
								style: {
									marginBottom: "20px"
								}
							},
						},
						grid: [{
								bill_name: 24,
							},
							{
								rate_time: 24,
							},
							{
								remarks: 24,
							}
						],
						fields: [{
			 				name: () => this.$t("Remarks"),
								key: "remarks",
								component: "Input",
								bind: {
									type: "textarea",
									rows: 2
								},
								placeholder() {
									return this.$t("enter") + this.$t("Remarks");
								}
							},
		 				{
								name: () => this.$t("b2bName"),
								key: "bill_name",
								component: "Input",
								placeholder() {
									return this.$t("enter") + this.$t("b2bName");
								}
							},
							{
								key: "rate_time",
								name: () => this.$t("rate") + this.$t('date'),
								component: "DatePicker",
								placeholder: () => this.$t("select") + this.$t("rate") + this.$t('date'),
								bind: {
									type: "month",
									style: {
										width: "100%"
									}
								},
								disabledDate: true,
								methods: {
									format({
										value
									}) {
										return this.format.monthFormat(value) || "";
									},
								}
							},
						]
					},
					upload: {
						methods: {
							ok() {
				  		window.open(
									this.$globalUrl + "/doc/zh-CN/dispatch.xlsx"
								);
							}
				 	},
						footer: {
							cancel: {
								isShow: true
							},
							ok: {
								name: this.$t("download_tem")
							}
						},
						config: {
							modalBind: {
								width: 500,
								draggable: true,
								maskClosable: false
							},
				 		rowBind: {
								gutter: 16
								// style: {
								//   marginBottom: "20px"
								// }
							},
				 		title: this.$t("upload") + this.$t("files")
						},
						grid: [{
							files: 24
						}],
						fields: [{
							key: "files",
							component: "Upload",
							bind: {
								type: "drag",
								accept: ".xlsx"
							},
							methods: {
								beforeUpload: ({
									file
								}) => {
									let formData = new FormData();
									formData.append("file", file); // 文件对象
									let _this = this.$refs["table"];
									_this
										.handleRequestMethods("Upload", formData)
										.then(res => {
											_this.$Message["success"]({
				   					background: true,
												content: res.msg
											});
											_this.getModal("upload").close();
										});
				   		return false;
								}
							}
						}]
					},
				},
				header: {
					searchs: [{
							key: "agent_id",
							component: "Select",
							placeholder() {
								return this.$t("select") + this.$t("agentName");
							},
							clearable: true,
							options: [],
							config: {
								label: "agent_name",
								value: "id"
							},
							methods: {
								list({
									field
								}) {
									getAgent().then(res => {
										if (res.data.status) {
											field.options = res.data.payload.rows
										}
									})
								}
							}
						},
						{
							key: "client_id",
							placeholder() {
								return this.$t("select") + this.$t("clientName");
							},
							component: "Select",
							config: {
								value: "id",
								label: "account",
							},
							methods: {
								async list({
									field
								}) {
									field.options = (
										await this.$page.handleRequestMethods("getAllClient")
									).payload.rows;
									this.$forceUpdate();
								},
							},
						},
						{
							key: "type",
							component: "Select",
							placeholder() {
								return this.$t("select") + this.$t("type");
							},
							options: [],
						},
						{
							key: "from_country",
							component: "Select",
							placeholder() {
								return this.$t("select") + this.$t("from_country");
							},
							options: [],
							config: {
								label: "code",
								value: "code"
							}
						},
						{
							key: "to_country",
							component: "Select",
							placeholder() {
								return this.$t("select") + this.$t("target_country");
							},
							options: [],
							config: {
								label: "code",
								value: "code"
							},
						},
						{
							key: "keywords",
							placeholder() {
								return this.$t("keyword");
							},
							component: "Input",
							bind: {
								type: "textarea",
								autosize: {
									minRows: 2,
									maxRows: 2
								}
							}
						}
					],
					btns: {
						list: [{
								name: () => this.$t("export"),
								type: "export",
								fnName: "export",
								bind: {
									icon: "md-arrow-down",
									type: "primary"
								}
							},
							{
								name: () =>
									this.$t('ModificationCost') +
									this.$t("import"),
								type: "upload",
								fnName: "upload",
								bind: {
									type: "warning"
								}
							},
							{
								name: () => this.$t("createBill"),
								type: "createBill",
			 				fnName: "createBill",
								bind: {
									icon: "md-add",
									type: "warning",
								},
								id: 1533,
							},
						],
						methods: {
							createBill({
								searchForm
							}) {
								let ids = this.selectAll.map(t => t.id)
								this.getModal('createBill').open({
									...searchForm,
									ids,
									rate_time: new Date()
								})
							},
							upload() {
								this.getModal("upload").open();
							},
							export({searchForm}) {
								this.handleRequestMethods('list',{...searchForm,export:1,ids:this.selectAll.map(t=>t.id)}).then(res=>{
									console.log(res);
									window.open(this.$globalUrl + res.payload.src)
								},true,true)
								// this.exportExc();
							},
						}
					}
				},
				fields: [{
						type: "checkbox",
						align: "center",
						width: 60,
						key: 'checkbox',
					},
					{
						name: () => this.$t("order_number"),
						key: 'airway_number',
						copy: true,
						header: {
							copy: true
						},
						align: "center",
						minWidth: 130
					},
					{
						name: () => this.$t("distribution_agent"),
						key: 'agent_name',
						align: "center",
						minWidth: 130
					},
					{
						name: () => this.$t("clientName"),
						key: 'client_name',
						align: "center",
						minWidth: 130
					},
					{
						name: () => this.$t("allow_depart"),
						key: 'from_country',
						align: "center",
						minWidth: 130
					},
					{
						name: () => this.$t("target_country"),
						key: 'to_country',
						align: "center",
						minWidth: 130
					},
					{
						name: () => this.$t("PODType"),
						key: 'type',
						align: "center",
						minWidth: 130
					},
					{
						name: () => this.$t("billingCurrency"),
						key: 'currency',
						align: "center",
						minWidth: 130
					},
					{
						name: () => this.$t("cost_t"),
						key: 'amount',
						align: "center",
						minWidth: 130
					},
					{
						name: () => this.$t("to_rmb") + this.$t('rate'),
						key: 'to_rate',
						align: "center",
						minWidth: 130
					},
					{
						name: () => this.$t("to_rmb") + this.$t('reChAmount'),
						key: 'to_amount',
						align: "center",
						minWidth: 130
					},
					{
						name: () => this.$t("bill_number"),
						key: 'bill_number',
						align: "center",
						minWidth: 130
					},
				]
			};
		},
		async mounted() {
			let fromCountry = await getCountry({
				allow_depart: 1
			});
			let toCountry = await getCountry({
				allow_arrive: 1
			});
			let type = await getSelectType('ORDER_DELIVER_COST_KEYWORDS');
			this.header.searchs.forEach(item => {
				if (item.key === "type")
					item.options = type.data.payload['ORDER_DELIVER_COST_KEYWORDS'];
				if (item.key === "from_country")
					item.options = fromCountry.data.payload.rows;
				if (item.key === "to_country") item.options = toCountry.data.payload.rows;
			})
		}
	};
</script>
